export var AutocompleteOptionType;
(function (AutocompleteOptionType) {
    AutocompleteOptionType["CheckBox"] = "checkbox";
    AutocompleteOptionType["CheckIcon"] = "checkicon";
    AutocompleteOptionType["RadioButton"] = "radio";
})(AutocompleteOptionType || (AutocompleteOptionType = {}));
